<template>
	<div>
		<van-nav-bar title="小程序踢人设置" left-text="返回" left-arrow fixed placeholder @click-left="onClickLeft" v-show="this.$UserAgent.indexOf('Html5Plus')==-1?true:false" />
		<van-form @submit="onSubmit">
			<van-field name="switch_checked" label="功能总开关">
				<template #input>
					<van-switch v-model="switch_checked" size="20" />
				</template>
			</van-field>
			
			<div style="margin-left: 0.2rem;">
				<p style="font-size: 10px;font-weight: bold;color: #1989fa;">检测到群员发小程序警告踢出(管理员除外)</p>
			</div>
			
			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit">
					提交
				</van-button>
			</div>
		</van-form>
	</div>


</template>

<script>
	export default {
		data() {
			return {
				group_id: 0,
				switch_checked: false,
				op: 'amini'
			}
		},
		created() {
			var group_id = localStorage.getItem('select_id')
			if (!group_id) {
				this.$router.push('/member-center')
				return;
			}
			this.group_id = group_id

			this.$ApiUtil.GroupCenterSrc.get({
				a: group_id,
				v: this.op
			}).then(res => {
				if (res.status) {
					this.switch_checked = res.data.switch_checked
				}
			})
		},
		methods: {
			onClickLeft() {
				this.$router.back()
			},
			onSubmit(values) {
				this.$ApiUtil.GroupCenterSrc.post({
					op: this.op,
					id: this.group_id,
					values: JSON.stringify(values)
				}).then(res => {
					if (!res.status) {
						this.$toast.fail(res.message)
					}
						this.$toast.success('已保存')
				})
			},
		}
	}
</script>

<style>
</style>
